export default __webpack_public_path__ + "static/media/account.a7c953b3.png";